import React from 'react';

interface ITitleProps {
  children: React.ReactNode;
}

export const Title: React.FC<ITitleProps> = ({ children }) => (
  <span className="tw-lf-body-bold-sm tw-grid-area-[title]">{children}</span>
);
